import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/common-banner-bg-BMBchR2h.jpg'
import { useIntl } from 'react-intl';

const TravBusinessProgrammeWorksPage: React.FC = () => {
  const intl = useIntl();
  
  const tocItems: ITableOfContentItem[] = [
    { id: 'programme-overview', title: intl.formatMessage({ id: 'programme.works.overview.title' }) },
    { id: 'registration-process', title: intl.formatMessage({ id: 'programme.works.registration.title' }) },
    { id: 'membership-levels', title: intl.formatMessage({ id: 'programme.works.membership-levels.title' }) },
    { id: 'earning-commission', title: intl.formatMessage({ id: 'programme.works.earning-commission.title' }) },
    { id: 'booking-process', title: intl.formatMessage({ id: 'programme.works.booking-process.title' }) },
    { id: 'payment-schedule', title: intl.formatMessage({ id: 'programme.works.payment-schedule.title' }) },
    { id: 'tools-and-resources', title: intl.formatMessage({ id: 'programme.works.tools-resources.title' }) },
    { id: 'support-and-training', title: intl.formatMessage({ id: 'programme.works.support-training.title' }) },
    { id: 'terms-and-conditions', title: intl.formatMessage({ id: 'programme.works.terms-conditions.title' }) },
  ];

  const sections: IContentSection[] = [
    {
      id: 'programme-overview',
      title: intl.formatMessage({ id: 'programme.works.overview.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.overview.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.overview.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.overview.paragraph.3' }),
      ],
    },
    {
      id: 'registration-process',
      title: intl.formatMessage({ id: 'programme.works.registration.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.registration.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.registration.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.registration.paragraph.3' }),
      ],
    },
    {
      id: 'membership-levels',
      title: intl.formatMessage({ id: 'programme.works.membership-levels.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.membership-levels.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.membership-levels.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.membership-levels.paragraph.3' }),
      ],
    },
    {
      id: 'earning-commission',
      title: intl.formatMessage({ id: 'programme.works.earning-commission.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.earning-commission.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.earning-commission.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.earning-commission.paragraph.3' }),
      ],
    },
    {
      id: 'booking-process',
      title: intl.formatMessage({ id: 'programme.works.booking-process.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.booking-process.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.booking-process.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.booking-process.paragraph.3' }),
      ],
    },
    {
      id: 'payment-schedule',
      title: intl.formatMessage({ id: 'programme.works.payment-schedule.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.payment-schedule.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.payment-schedule.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.payment-schedule.paragraph.3' }),
      ],
    },
    {
      id: 'tools-and-resources',
      title: intl.formatMessage({ id: 'programme.works.tools-resources.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.tools-resources.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.tools-resources.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.tools-resources.paragraph.3' }),
      ],
    },
    {
      id: 'support-and-training',
      title: intl.formatMessage({ id: 'programme.works.support-training.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.support-training.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.support-training.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.support-training.paragraph.3' }),
      ],
    },
    {
      id: 'terms-and-conditions',
      title: intl.formatMessage({ id: 'programme.works.terms-conditions.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'programme.works.terms-conditions.paragraph.1' }),
        intl.formatMessage({ id: 'programme.works.terms-conditions.paragraph.2' }),
        intl.formatMessage({ id: 'programme.works.terms-conditions.paragraph.3' }),
      ],
    },
  ];

  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'programme.works.headerTitle' })}
        headerSubtitle={intl.formatMessage({ id: 'programme.works.headerSubtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravBusinessProgrammeWorksPage;
